import { useMemo } from "react";

import { preparePresets } from "app/components/dashboard/widget-wizard/components/DashboardWizardDuration";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { getMonitorAndProtectConfig } from "../../../data/component-config/component-config";
import { useSocialChannelsDataAndParams } from "../../../hooks/social-channels-params";
import DurationSelector from "../components/duration/DurationSelectorSimple";
import type { IFilter } from "../FiltersBar";

const DurationFilterItem = () => {
    const { duration } = useSocialChannelsDataAndParams();
    const config = getMonitorAndProtectConfig();

    // Reuse the monthly presets swSettings derives from the component's date range
    // (same source the other Ad Intelligence calendars use), but force monthly
    // granularity so the 28d window preset keeps the month-grid selected.
    const defaultPresets = useMemo(
        () =>
            preparePresets(config.datePickerPresets).map((preset) => ({
                ...preset,
                id: String(preset.id),
                title: "duration.title",
                tooltipContent: "",
                value: { ...preset.value, isDaily: false },
            })),
        [config.datePickerPresets],
    );

    return (
        <DurationSelector
            key="monthly"
            minDate={config.startDate}
            maxDate={config.endDate}
            isDisabled={false}
            height="60px"
            presets={defaultPresets}
            initialPreset={duration}
            initialComparedDuration={false}
            onSubmit={(durationChanged) =>
                proNavigator.updateQueryParams({ duration: durationChanged }, { reload: false })
            }
            componentConfigId="Home"
        />
    );
};

export const durationFilterConfigItem: IFilter = {
    id: "duration",
    filter: <DurationFilterItem />,
};
